"use strict";

const ImgSrcOnError = angular
    .module("ImgSrcOnError", [])
    .directive("pwImgSrcOnError", imgSrcOnError);

function imgSrcOnError() {
    return {
        link: function (scope, element, attrs) {
            element.bind("error", function () {
                if (attrs.src != attrs.pwImgSrcOnError) {
                    attrs.$set("src", attrs.pwImgSrcOnError);
                }
            });
        }
    };
}

export default ImgSrcOnError;
